export default __webpack_public_path__ + "static/media/hemodiag.cab63d78.jpg";